const menuToggle = document.getElementById("menu-toggle");

menuToggle.addEventListener("click", (e) => {
    if (menuToggle.classList.contains("is-active")) {
        menuToggle.classList.remove("is-active");
        document.body.classList.remove("nav-open");
    } else {
        menuToggle.classList.add("is-active");
        document.body.classList.add("nav-open");
    }
});

document.querySelector(".site-nav").addEventListener("click", (e) => {
    if (e.target.classList.contains("scroll-link")) {
        menuToggle.classList.remove("is-active");
        document.body.classList.remove("nav-open");
    }
});